/**
 * @generated SignedSource<<431f097b66b7da2f04d643fc2bfdc196>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type GoldSubscriptionStatusType = 'GOLD' | 'GOLD_MONTHLY' | 'NONE' | '%future added value';
export type GoldMembershipPageQuery$variables = Record<PropertyKey, never>;
export type GoldMembershipPageQuery$data = {
  readonly authIdentity: {
    readonly goldContext: {
      readonly annualFeeMicro: number;
      readonly subscriptionStatus: GoldSubscriptionStatusType;
    };
    readonly id: string;
  };
};
export type GoldMembershipPageQuery = {
  response: GoldMembershipPageQuery$data;
  variables: GoldMembershipPageQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
    {
      alias: null,
      args: null,
      concreteType: 'Identity',
      kind: 'LinkedField',
      name: 'authIdentity',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'id',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          concreteType: 'GoldContext',
          kind: 'LinkedField',
          name: 'goldContext',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'subscriptionStatus',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'annualFeeMicro',
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
      storageKey: null,
    },
  ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'GoldMembershipPageQuery',
      selections: v0 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'GoldMembershipPageQuery',
      selections: v0 /*: any*/,
    },
    params: {
      cacheID: 'e0d65485dcd1d40ea130b9ad44e57203',
      id: null,
      metadata: {},
      name: 'GoldMembershipPageQuery',
      operationKind: 'query',
      text: 'query GoldMembershipPageQuery {\n  authIdentity {\n    id\n    goldContext {\n      subscriptionStatus\n      annualFeeMicro\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '926bf19c3e10cb78a8fd22ac626766f0';

export default node;
